import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";
import CtaBand from "@/components/CtaBand";
import { Reveal } from "@/components/Reveal";
import { ARTICLES } from "@/data/articles";

export default function ArticlePage() {
  const { slug } = useParams();
  const article = ARTICLES.find((a) => a.slug === slug);

  if (!article) return <Navigate to="/insights" replace />;

  return (
    <>
      <Seo
        title={`${article.title} — Improve Systems`}
        siteName="Improve Systems"
        description={article.excerpt}
        type="article"
      />
      <article data-testid="article-page">
        <header className="relative overflow-hidden border-b border-line">
          <div
            className="pointer-events-none absolute inset-0"
            style={{
              backgroundImage:
                "linear-gradient(to right, rgba(15,23,42,0.045) 1px, transparent 1px)",
              backgroundSize: "25% 100%",
            }}
            aria-hidden="true"
          />
          <div className="relative mx-auto max-w-3xl px-6 pb-14 pt-32 sm:pt-40">
            <Reveal>
              <Link
                to="/insights"
                data-testid="article-back-link"
                className="mb-10 inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.25em] text-slate-500 transition-colors hover:text-ink"
              >
                <ArrowLeft className="h-3.5 w-3.5" />
                ALL INSIGHTS
              </Link>
              <p className="flex items-center gap-4 font-mono text-[10px] tracking-[0.3em] text-slate-400">
                <span>{article.tag}</span>
                <span className="h-px w-6 bg-slate-300" aria-hidden="true" />
                <span>{article.date.toUpperCase()}</span>
              </p>
              <h1 className="mt-6 font-serif text-3xl leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
                {article.title}
              </h1>
            </Reveal>
          </div>
        </header>

        <div className="mx-auto max-w-3xl px-6 py-14 sm:py-20">
          {article.body.map((block, i) =>
            block.startsWith("## ") ? (
              <Reveal key={i}>
                <h2 className="mb-6 mt-12 font-serif text-2xl text-ink sm:text-3xl">
                  {block.slice(3)}
                </h2>
              </Reveal>
            ) : (
              <Reveal key={i}>
                <p className="mb-7 text-base leading-relaxed text-slate-700 sm:text-lg">
                  {block}
                </p>
              </Reveal>
            )
          )}
          <Reveal>
            <p className="mt-14 border-t border-line pt-8 font-mono text-[10px] tracking-[0.3em] text-slate-400">
              IMPROVE SYSTEMS — UNDERSTAND. IMPROVE. MONITOR.
            </p>
          </Reveal>
        </div>
      </article>
      <CtaBand />
    </>
  );
}
